import React, { FC } from 'react';
import styled from 'styled-components';

import { EmptyStateWrapper } from 'src/presentation/components/pages/shared/TableList';

type AudiencesEmptyStateProps = {
  actions: any;
};

const AudiencesEmptyState: FC<AudiencesEmptyStateProps> = ({ actions }) => {
  return (
    <EmptyStateWrapper data-aid={`audiences-empty-message`}>
      <StyledContent>
        <p>
          Need help setting up an Audience? Check out our{' '}
          <a href="https://help.gladly.com/docs/what-is-answers#answers-by-audience">Help Docs</a>
        </p>
        {actions}
      </StyledContent>
    </EmptyStateWrapper>
  );
};

export default AudiencesEmptyState;

const StyledContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  line-height: 162%;
  padding-bottom: 32px;
  margin-top: 200px;
  margin-bottom: 300px;
`;
